<template>
    <div>
        <div class="max-w-2xl md:max-w-3xl bg-white mx-auto">
            <textarea class="w-full h-64 mb-6 text-justify" name="termo" id="termo" cols="30" rows="10">TERMOS DE USO E POLÍTICA DE PRIVACIDADE

A Secretaria de Estado de Desenvolvimento Econômico, Ciência, Tecnologia e Inovação – SEDECTI estabelece neste Termo de Uso e Política de Privacidade as informações a respeito de como será tratado os dados pessoais das empresas que preencherem o FORMULÁRIO, os motivos da coleta e da forma como a empresa poderá excluir estas informações.

Esta Política de Privacidade foi elaborada em conformidade com a Lei Federal nº 12.965, de 23 de abril de 2014 (Marco Civil da Internet), e com a Lei Federal nº 13.709, de 14 de agosto de 2016 (Lei de Proteção dos Dados Pessoais).

Leia atentamente o seguinte TERMO, pois ele se aplica ao FORMULÁRIO que será preenchido.

Ao preencher o FORMULÁRIO e enviar os dados, você estará concordando e declarando estar ciente com este TERMO.

CLÁUSULA PRIMEIRA – DO OBJETO: FORMULÁRIO DE INCLUSÃO/ALTERAÇÃO CADASTRAL DE DADOS CADASTRAIS

Com o único intuito de acompanhar o andamento das empresas durante o enfretamento da pandemia causada pelo COVID-19, a SEDECTI disponibiliza o DOCUMENTO/FORMULÁRIO DE INCLUSÃO/ALTERAÇÃO DE DADOS CADASTRAIS, chamado neste Termo somente de FORMULÁRIO, disponibilizado no site www.paineleconomia.am.gov.br, que tem a finalidade de possibilitar as Pessoas Jurídicas o cadastramento ou a atualização dos seus dados cadastrais perante a SEDECTI para produção de representações gráficas resultantes da compilação dos mesmo publicadas no domínio www.paineleconomia.am.gov.br, realização de estudos, análise, tomadas de decisões, e elaboração de políticas públicas.

O objeto do presente Termo é realizar estudos, análise, produção de representações gráficas , tomadas de decisões e elaboração de políticas públicas com as informações apresentadas pelas Pessoas Jurídicas, por intermédio do DOCUMENTO/FORMULÁRIO DE INCLUSÃO/ALTERAÇÃO DE DADOS CADASTRAIS, chamado apenas de FORMULÁRIO, disponibilizado pela SEDECTI no site www.paineleconomia.am.gov.br, para acompanhar o andamento das empresas durante o enfrentamento da pandemia causada pelo CONVID-19.

CLÁUSULA SEGUNDA – DA POLÍTICA DE PRIVACIDADE

II.I. Os dados serão coletados e utilizados apenas para as finalidades aqui determinadas, explícitas e legítimas, não podendo ser tratados posteriormente de uma forma incompatível com essas finalidades.

II.II. Os dados pessoais da empresa serão exatos e atualizados sempre que necessário, de maneira que os dados inexatos sejam apagados ou retificados quando possível;

II.III. Os dados pessoais das empresas serão tratados de forma segura, protegidos do tratamento não autorizado ou ilícito e contra a sua perda, destruição ou danificação acidental, adotando as medidas técnicas ou organizativas adequadas;

II.IV.A SEDECTI se compromete a não divulgar, publicar ou compartilhar o nome e a localização dos interessados que preencherem o Formulário .

II.V O compartilhamento dos dados só será permitido com autorização prévia do titular do CNPJ, seu representante legal e/ou seu procurador por e-mail.

CLÁUSULA TERCEIRA - RESPONSABILIDADES LEGAIS

III.I. O titular do CNPJ, seu representante legal e/ou seu procurador, obrigam-se a FORNECER somente informações FIDEDÍGNAS e atualizadas a respeito do titular do CNPJ, responsabilizando-se integralmente pela inobservância de tal obrigação, inclusive pela caracterização de ato ilícito, como por exemplo, a falsidade ideológica, tipificada nos termos do artigo 299 do Código Penal, sujeitando-se as penalidades legalmente previstas.

III.II. O titular do CNPJ, seu representante legal e/ou seu procurador, responsabilizam-se por quaisquer danos oriundos do fornecimento de informações falsas e/ou inverídicas causados à SEDECTI e/ou a terceiros.

III.III. O titular do CNPJ, seu representante legal e/ou seu procurador, responsabilizam-se pela observância das disposições contidas neste Termo e eximem a SEDECTI de qualquer responsabilidade neste âmbito, inclusive perante terceiros.

III.IV. A SEDECTI não é responsável por nenhum prejuízo resultante do preenchimento do FORMULÁRIO em seu “site”, bem como pelo uso das informações em forma de análise publicadas como resultado da compilação de dados constantes do referido formulário por parte de terceiros.

III. V. Sempre que solicitado pela SEDECTI, o titular do CPNJ, seu representante legal e/ou seu procurador estão obrigados a apresentar documentos que comprovem as informações inseridas no FORMULÁRIO.

CLÁUSULA QUARTA - VEDAÇÕES

IV.I. O titular do CNPJ, seu representante legal e/ou seu procurador, se o caso, estão legalmente obrigados a:

NÃO utilizar o FORMULÁRIO de forma a violar dispositivo legal ou regulamentos;

NÃO utilizar o o FORMULÁRIO de forma a violar direito de terceiros;

NÃO forjar dados ou manipulá-los de forma a dissimular o conteúdo e/ou a origem de qualquer das informações fornecidas à SEDECTI;

NÃO fornecer e possibilitar a divulgação de informações falsas, relativas a terceiros, inválidas, incorretas ou incompletas;

NÃO utilizar o FORMULÁRIO e os serviços colocados à disposição pela SEDECTI para fins ilícitos;

NÃO utilizar o FORMULÁRIO de forma a prejudicar a SEDECTI ou o sistema colocado à disposição por ela.

CLÁUSULA QUINTA – DECLARAÇÕES

V.I. O titular do CNPJ, seu representante legal e/ou seu procurador declaram que:

FORNECERÃO para a SEDECTI dados próprios, verdadeiros e válidos;

ESTÃO cientes da finalidade do preenchimento do FORMULÁRIO mencionado neste documento;

AUTORIZAM e solicitam à SEDECTI o cadastramento das informações disponibilizadas no FORMULÁRIO, bem como todas as demais informações relativas ao seu comportamento, para o compartilhamento com o público em geral e outras instituições que tenham acesso a este Painel da Economia online, para subsidiar pesquisas de mercado, estudos e decisões de negócios e/ou realização de ações;

TÊM ciência de que poderão ter acesso, a qualquer tempo, às informações cadastradas e de que, não sendo corretos ou não correspondendo à verdade, poderão pedir a sua modificação, o seu cancelamento ou o registro de anotação complementar, mediante requerimento fundamentado;

ESTÃO cientes de que a SEDECTI poderá, em certas circunstâncias e sem aviso prévio, interromper, temporária ou definitivamente a disponibilização das informações ao público bem como excluí-las do seu banco de dados.

CLÁUSULA SEXTA – ACEITAÇÃO

Após o preenchimento do FORMULÁRIO, o titular do CNPJ, seu representante legal e/ou seu procurador manifestarão a sua concordância com todos os termos e condições deste TERMOS DE USO E POLÍTICA DE PRIVACIDADE</textarea>
            <label for="aceite" class="mb-6 cursor-pointer">
                <input v-model="aceite" id="aceite" type="checkbox" name="aceite"/> Aceito todos os termos de uso
            </label>
            <button @click.prevent="goto" :disabled="!aceite" :class="{'bg-gray-500':!aceite, 'bg-pink-500': aceite}"
                    class="w-full md:w-auto block ml-auto text-sm rounded-full text-white px-10 py-2 md:text-base font-bold"
                    type="submit">
                Avançar
            </button>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'

    export default Vue.extend({
        data() {
            return {
                aceite: false
            }
        },
        methods: {
            goto() {
                this.$store.commit('clearAll')
                this.$store.commit('aceitarTermos')
                this.$router.push({name: 'CadastroPerfil'})
            }
        }
    })
</script>